export function getPublicSiteUrl() {
    const envUrl = String(import.meta.env.VITE_PUBLIC_SITE_URL || "")
        .trim()
        .replace(/\/+$/, "");

    if (envUrl) return envUrl;

    if (typeof window !== "undefined" && window.location?.origin) {
        return String(window.location.origin).replace(/\/+$/, "");
    }

    return "";
}

export function getAuthRedirectUrl(path = "/auth/callback") {
    const base = getPublicSiteUrl();
    if (!base) return path;

    const cleanPath = String(path || "/").startsWith("/") ? path : `/${path}`;
    return `${base}${cleanPath}`;
}